import { call, put, takeLatest } from "redux-saga/effects";
import { CREATE_LOCATION, FETCH_ALL_LOCATIONS_WITH_STATUS, FETCH_LOCATION_LIST, UPDATE_LOCATION } from "./types";
import {
  createLocationService,
  fetchLocationsService,
  updateLocationService,
  getAllLocationsWithUserStatusService,
} from "../../services";
import { setAllLocationsWithStatus, setAllLocationsWithStatusError, setAllLocationsWithStatusLoading, setLocations } from "./slice";
import { setAlert } from "../basicSlices";

function* handleLoadLocations(
  { payload }: { payload?: any } = { payload: undefined }
): Generator<any> {
  try {
    const responseData: any = yield call(fetchLocationsService);
    payload?.callback && payload?.callback(responseData);

    yield put(setLocations(responseData));
  } catch (error: any) {
    yield put(
      setAlert({
        text: error?.message,
        type: "danger",
        title: "Failed to fetch Locations!",
      })
    );
    payload?.callback && payload?.callback(true);
  }
}

function* handleCreateLocation({ payload }: { payload: any }): Generator<any> {
  try {
    const responseData: any = yield call(createLocationService, payload);
    // yield handleLoadLocations();
  } catch (error: any) {
    yield put(
      setAlert({
        text: error?.message,
        type: "danger",
        title: "Failed to add new Location!",
      })
    );
  } finally {
    payload?.callback && payload?.callback();
  }
}

function* handleUpdateLocation({ payload }: { payload: any }): Generator<any> {
  try {
    const responseData: any = yield call(updateLocationService, payload);
    // yield handleLoadLocations();
  } catch (error: any) {
    yield put(
      setAlert({
        text: error?.message,
        type: "danger",
        title: "Failed to update the Location!",
      })
    );
  } finally {
    payload?.callback && payload?.callback();
  }
}


function* handleFetchAllLocationsWithStatus(
  { payload }: { payload?: any } = { payload: undefined }
): Generator<any> {
  try {
    yield put(setAllLocationsWithStatusLoading());

    const responseData: any = yield call(
      getAllLocationsWithUserStatusService,
      payload
    );

    payload?.callback && payload?.callback(responseData);

    yield put(setAllLocationsWithStatus(responseData));
  } catch (error: any) {
    yield put(
      setAllLocationsWithStatusError(error?.message ?? "Something went wrong")
    );
    yield put(
      setAlert({
        text: error?.message,
        type: "danger",
        title: "Failed to fetch Locations with status!",
      })
    );
    payload?.callback && payload?.callback(true);
  }
}

export default function* locationSaga() {
  yield takeLatest<any>(FETCH_LOCATION_LIST, handleLoadLocations);
  yield takeLatest<any>(CREATE_LOCATION, handleCreateLocation);
  yield takeLatest<any>(UPDATE_LOCATION, handleUpdateLocation);
  yield takeLatest<any>(FETCH_ALL_LOCATIONS_WITH_STATUS, handleFetchAllLocationsWithStatus);
}
